import { createContext, useContext, type ReactNode } from 'react';

const PlatformSidebarCollapsedContext = createContext(false);

export function PlatformSidebarCollapsedProvider({
  collapsed,
  children,
}: {
  collapsed: boolean;
  children: ReactNode;
}) {
  return (
    <PlatformSidebarCollapsedContext.Provider value={collapsed}>
      {children}
    </PlatformSidebarCollapsedContext.Provider>
  );
}

export function usePlatformSidebarCollapsed(): boolean {
  return useContext(PlatformSidebarCollapsedContext);
}
